/**
 * Enum which defines the order menu type.
 *
 * @type {{ALL: string, BUILDABOX: string, USER: string}}
 */
export const ORDER_MENU_TYPE = {
  BUILDABOX: 'buildabox',
  CATERER: 'caterer',
  CUSTOM: 'custom',
  ALL: 'all'
}